import { Form } from 'antd';
import { getRules, getForm } from './util';
import { fieldTypeMap } from '@/utils/constants';

//form.item里面不能存在其他标签，所以用函数代替标签写法
const DynamicForm = (props) => {
    return props.field_type === fieldTypeMap.DATE || props.field_type === fieldTypeMap.FILE || props.field_type === 4 || props.field_type === 3 ? (
        getForm(props)
    ) : (
        <Form.Item key={props.field_id} label={props.label === undefined ? props.name : props.label} name={props.en_name} rules={getRules(props)}>
            {getForm(props)}
        </Form.Item>
    );
};
export default DynamicForm;
